import React from "react";

const ContratoAprovado = () => {
  return <div>ContratoAprovado</div>;
};

export default ContratoAprovado;
